<template>
    <div class="card">
        <div class="card-header">
            Naplánovat návštěvu
        </div>
        <!--<div class="card-body">
            {{ visit }}
            <modal :show="showModal" @close="showModal = false"></modal>
            <button id="show-modal" @click="showModal = true">New Post</button>
        </div>-->
        <div class="card-body">
            <form class="form-inline" @submit.prevent="postVisit">
                <label class="mr-sm-2" for="doctor">K doktorovi</label>
                <select v-model="visit.doctorid" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat doktora" v-on:change="loadCalendar()">
                    <option value="" disabled selected>zvolit doktora</option>
                    <option v-for="row in doctors" v-bind:value="row.id">{{ row.fullname }}</option>
                </select>
                <select v-model="visit.branchid" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="doctor" placeholder="vybrat pobočku" v-on:change="loadCalendar()">
                    <option value="" disabled selected>zvolit pobočku</option>
                    <option v-for="row in branches" v-bind:value="row.id">{{ row.label }}</option>
                </select>
                <small id="doctorHelp" class="form-text text-muted"></small>
                <label for="operation" class="mr-sm-2">za účelem</label>
                <!--<input v-model="visit.operation" type="text" class="form-control mr-sm-2" aria-describedby="operationHelp" id="operation">-->
                <select v-model="purposeid" class="form-control mr-sm-2" aria-describedby="operationHelp" id="operation" @change="changeVisitDuration">
                    <!-- <option v-for="visit_purpose in visit_purposes" :value="visit_purpose.purpose">{{ visit_purpose.purpose }} - {{ visit_purpose.duration *6 }} minut</option>-->
                    <option v-for="visit_purpose in visit_purposes" :value="visit_purpose.id">{{ visit_purpose.purpose }}</option>
                </select>
                <small id="operationHelp" class="form-text text-muted"></small>

                <label for="duration" class="mr-sm-2">Délka návštěvy:</label>
                <select @change="changeSelectedWindows()" v-model="visit.duration" class="form-control mr-sm-2" id="duration">
                    <option value="" disabled selected>zvolit čas</option>
                    <option v-for="duration in 24" v-bind:value="duration">{{ duration*5 }} minut</option>
                </select>
                <button v-if="!waitForSave" type="submit" class="btn btn-primary">Přidat návštěvu</button>
                <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>

            </form>
            <br>
            <div v-if="actual_select.selected">
                {{ moment(actual_select.date).format('dddd') }} {{ moment(actual_select.date).format('LL') }} v {{ moment(actual_select.date).format('LT') }}<br>
            </div>
            <div v-else>
                Vyberte den a čas v kalendáři
            </div>
            <hr>
            <div class="justify-content-between d-flex">
                <div>
                    <button @click="previousPeriod() + getVisits()" type="button" class="btn btn-primary">Předchozí</button>
                </div>
                <div class="btn-group" data-toggle="buttons">
                    <label class="btn btn-primary" :class="{ active: calendarSize === 'day' }">
                        <input type="radio" name="options" id="option1" autocomplete="off" v-model="calendarSize" value="day"> den
                    </label>
                    <label class="btn btn-primary" :class="{ active: calendarSize === 'week' }">
                        <input type="radio" name="options" id="option2" autocomplete="off" v-model="calendarSize" value="week"> týden
                    </label>
                    <label class="btn btn-primary" :class="{ active: calendarSize === 'month' }">
                        <input type="radio" name="options" id="option3" autocomplete="off" v-model="calendarSize" value="month"> měsíc
                    </label>
                </div>
                <div>
                    <button @click="nextPeriod() + getVisits()" type="button" class="btn btn-primary">Následující</button>
                </div>
            </div>
            <div class="justify-content-between d-flex">
                <div>

                </div>
                <div>
                    {{ get_params.from }} - {{ get_params.to }}
                </div>
                <div>

                </div>
            </div>
            <table class="table table_calendar" v-if="visit.doctorid">
                <thead>
                <tr>
                    <th></th>
                    <th v-for="(times, index) in ((endWindow-startWindow)/windowsPerHour)" :colspan="windowsPerHour">
                        {{ (index+startHour)<10 ? '0'+(index+startHour) : (index+startHour) }}
                    </th>
                </tr>
                <tr>
                    <th></th>
                    <th v-for="(times, index) in ((endWindow-startWindow)/(windowsPerHour/2))" :colspan="(windowsPerHour/2)" class="halfHour">
                        &nbsp;
                    </th>
                </tr>
                <tr>
                    <th></th>
                </tr>
                </thead>
                <tbody v-if="hasData">
                <tr v-for="n in (this.end_date.diff(this.start_date, 'days') + 1)">
                    <td>{{ moment(start_date).add(n - 1, 'days').format('dddd') }}<br><small>{{ moment(start_date).add(n - 1, 'days').format('L') }}</small></td>
                    <td v-for="(cell, indexTM) in (endWindow-startWindow)" :data-window-id="n + '_' +  (startWindow + cell - 1)" v-on:mouseover="hoverWindows" v-on:mouseleave="unhoverWindows" v-on:click="prepareVisit(startWindow + cell - 1, moment(start_date).add(n - 1, 'days'), $event)" :class="getRightClassForTd(visits[moment(start_date).add(n - 1, 'days').format('YYYY-MM-DD')][startWindow + cell - 1]) + ' ' + ((cell%windowsPerHour === 0) ? 'hourly' : '' ) + ' ' + ((cell%windowsPerHour === windowsPerHour/2) ? 'halfhourly' : '' )">
                        &nbsp;
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="card-body text-left">
            <router-link :to="{ name: 'ShowClient', params: { clientid: this.$route.params.clientid }}">
                zpět na klienta
            </router-link>
        </div>
    </div>
</template>

<script>
  // import auth from '../../auth'
  // import error from '../../error'

  import moment from 'moment'
  import Modal from './ConfirmVisitModal.vue'

  export default {
    data () {
      return {
        hasData: false,
        waitForSave: false,
        calendarSize: 'week',
        startWindow: 97, // TODO změnit ze settings ordinace (záčátek standardní pracovní doby)
        endWindow: 241, // TODO změnit ze setting ordinace (konec standardní pracovní doby)
        windowsPerHour: 12, // TODO změnit ze setting ordinace (velikost "okénka")
        startHour: 96 / 12,
        setting: require('../../../variables.js'),
        visits: [],
        doctors: '',
        branches: '',
        selectedWindow: null,
        lastDuration: '',
        visit_purposes: '',
        selected_element: null,
        visit: {
          date: '',
          clientid: this.$route.params.clientid,
          doctorid: 1,
          duration: 6, // TODO změnit ze settings ordinace (výchozí délka návštěvy)
          operation: ''
          // date: ''
        },
        get_params: {
          from: '',
          to: '',
          doctorid: ''
        },
        start_date: '',
        end_date: '',
        begin_of_month: '',
        end_of_month: '',
        today: moment(),
        actual_select: {
          selected: false,
          time: '',
          date: '',
          window: '',
          day: ''
        },
        showModal: false,
        purposeid: ''
      }
    },
    methods: {
      postVisit () {
        this.waitForSave = true
        this.visit.purposeid = this.purposeid
        this.$http.post(this.setting.hostname + 'visit', this.visit, {emulateJSON: true}).then(response => {
          this.waitForSave = false
          this.getVisits()
        }, response => {
          this.errors = response.data.errors
          this.waitForSave = false
        })
      },
      windowToTime (window) {
        window = window - 1
        var hour = Math.floor(window / this.windowsPerHour)
        var minute = (window % this.windowsPerHour) * 5
        return moment().hour(hour).minute(minute)
      },
      clearLastSelect () {
        if (this.selectedWindow) {
          var element = this.selectedWindow
          console.log(element.tagName)
          for (var i = 0; i < this.lastDuration; i++) {
            element.classList.remove('selected_window')
            element = element.nextSibling
          }
        }
      },
      prepareVisit (window, date, event) {
        this.actual_select.window = window
        this.actual_select.selected = true
        var forTime = this.windowToTime(window)
        this.actual_select.date = moment(date).hour(forTime.hour()).minute(forTime.minute())
        this.visit.date = moment(date).format('L')
        this.visit.timewindow = window

        this.clearLastSelect()
        var element = event.target
        this.selectedWindow = event.target
        // console.log(element.tagName)
        this.lastDuration = this.visit.duration
        for (var i = 0; i < this.visit.duration; i++) {
          element.classList.add('selected_window')
          element = element.nextSibling
        }
      },
      changeSelectedWindows () {
        if (this.selectedWindow) {
          var element = this.selectedWindow
          this.clearLastSelect()
          this.lastDuration = this.visit.duration
          for (var i = 0; i < this.visit.duration; i++) {
            element.classList.add('selected_window')
            element = element.nextSibling
          }
        }
      },
      getRightClassForTd (items) {
        var classes = ''
        items.forEach(function (item) {
          if (!classes.includes(item.type)) {
            classes = classes + ' ' + item.type
          } else {
            classes = classes + ' ' + item.type + '-multi'
          }
        })
        return classes
      },
      initialSet () {
        moment.locale('cs')
        this.actualPeriod()
      },
      getDoctors () {
        this.$http.get(this.setting.hostname + 'doctor').then(response => {
          this.doctors = response.data
        }, response => {
          // error callback
        })
      },
      getBranches () {
        this.$http.get(this.setting.hostname + 'branch').then(response => {
          this.branches = response.data
        }, response => {
          // error callback
        })
      },
      getVisits () {
        this.hasData = false
        this.get_params.from = moment(this.start_date).format('DD.MM.YYYY')
        this.get_params.to = moment(this.end_date).format('DD.MM.YYYY')
        this.get_params.doctorid = this.visit.doctorid
        this.$http.get(this.setting.hostname + 'visit', {params: this.get_params}).then(response => {
          // this.visits = JSON.parse(JSON.stringify(response.body))
          this.visits = response.data.visits
          this.hasData = true
        }, response => {
          //
        })
      },
      actualPeriod () {
        if (this.calendarSize === 'week') {
          this.start_date = moment().startOf('isoWeek')
          this.end_date = moment().endOf('isoWeek')
        } else if (this.calendarSize === 'month') {
          this.start_date = moment().startOf('month')
          this.end_date = moment().endOf('month')
        } else {
          this.start_date = moment()
          this.start_date = moment()
        }
      },
      nextPeriod () {
        if (this.calendarSize === 'week') {
          this.start_date = this.start_date.add(1, 'weeks')
          this.end_date = this.end_date.add(1, 'weeks')
        } else if (this.calendarSize === 'month') {
          this.start_date = this.start_date.add(1, 'months')
          this.end_date = this.end_date.add(1, 'months')
        } else {
          this.start_date = this.start_date.add(1, 'days')
          this.end_date = this.end_date.add(1, 'days')
        }
      },
      previousPeriod () {
        if (this.calendarSize === 'week') {
          this.start_date = this.start_date.subtract(1, 'weeks')
          this.end_date = this.end_date.subtract(1, 'weeks')
        } else if (this.calendarSize === 'month') {
          this.start_date = this.start_date.subtract(1, 'months')
          this.end_date = this.end_date.subtract(1, 'months')
        } else {
          this.start_date = this.start_date.subtract(1, 'days')
          this.end_date = this.end_date.subtract(1, 'days')
        }
      },
      loadCalendar () {
        this.getVisits()
      },
      moment: function (date) {
        return moment(date)
      },
      hoverWindows (event) {
        var element = event.target
        for (var i = 0; i < this.visit.duration; i++) {
          element.classList.add('hovered_window')
          element = element.nextSibling
        }
        // event.target.nextSibling.classList.add('green')
      },
      unhoverWindows (event) {
        var element = event.target
        for (var i = 0; i < this.visit.duration; i++) {
          element.classList.remove('hovered_window')
          element = element.nextSibling
        }
        // event.target.nextSibling.classList.remove('green')
      },
      getVisitPurposes () {
        this.waitForResponse = true
        this.$http.get(this.setting.hostname + 'visit_purpose').then(response => {
          this.visit_purposes = response.data
          this.visit_purposes.forEach(function (visitPurpose) {
            if (visitPurpose.default === true) {
              this.visit.operation = visitPurpose.purpose
              this.visit.duration = visitPurpose.duration
            }
          })
          this.waitForResponse = false
        }, response => {
          this.waitForResponse = false
        })
      },
      changeVisitDuration (event) {
        console.log(event.target.tagName)
      }
    },
    beforeMount () {
      this.getDoctors()
      this.initialSet()
      this.getVisitPurposes()
    },
    isSelected (indexD, indexTM) {
      return false
    },
    components: {
      Modal
    },
    watch: {
      purposeid: function (val) {
        //
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    table.table_calendar > thead > tr > th {
        margin: 0;
        padding: 0;
        font-size: x-small;
        border: none;
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:last-of-type {
        border-right: 1px solid #888;
    }

    table.table_calendar > thead > tr > th:first-of-type {
        border: none;
    }

    table.table_calendar > thead > tr > th.halfHour {
        border-left: 1px solid #888;
    }

    table.table_calendar > thead > tr > th.sixth_cell {
        border-right: 1px solid #888;
        background-color: dodgerblue;
    }

    table.table_calendar > tbody > tr > td {
        margin: 0;
        padding: 0;
        border: none;
        border-bottom: 1px solid #888;
        border-right: 1px solid #888;
    }

    table.table_day {
        margin: 0;
    }
    table.table_day td {
        padding: 0;
        margin: 0;
        border: none;
        border-right: 1px dotted black;
        padding: 10px 0 10px 0;
    }

    table.table_day td:last-of-type{
        border-right: none;
    }

    .icon-male {
        color: dodgerblue;
        font-weight: bold;
    }

    .icon-female {
        color: deeppink;
        font-weight: bold;
    }

    .table > tbody > tr > td, .table > tfoot > tr > td {
        vertical-align: middle;
    }

    td.selected {
        background-color: deeppink;
    }

    .highlight_hovered tr:hover {
        background-color: #ffa;
    }

    .visit {
        background-color: orange;
        opacity: 0.5;
    }

    .visit-multi {
        background-color: orangered;
        opacity: 0.5;
    }

    .unoccupied{
        background-color: greenyellow;
        opacity: 0.5;
    }

    .hovered_window {
        opacity: 0.9;
    }

    .selected_window {
        background-color: green;
    }

    .hovered_window.visit {
        background-color: orangered;
    }

    .selected_window.visit {
        background-color: red;
    }

    td.hourly {
        border-right: 1px solid black !important;
    }

    td.halfhourly {
        border-right: 1px solid #444 !important;
    }

    td:hover {
        opacity: 0.8;
        cursor:crosshair
    }

    .bold_text {
        font-weight: bold;
    }
    @media screen
    {
        .noPrint{}
        .noScreen{display:none;}
    }

    @media print
    {
        .noPrint{display:none;}
        .noScreen{}
    }


</style>



// WEBPACK FOOTER //
// src/views/Client/components/AddVisit.vue?82c929c6